export const CASH_OUT_ADDRESS_SAVE_RETRY_MESSAGE = 'Unable to save this address. Please try again.';

export const CASH_OUT_ADDRESS_SAVE_ENDPOINT = 'checkflo/address';

export const CASH_OUT_PHONE_MESSAGE = 'Enter a 10-digit phone number. Dashes, spaces, and parentheses are optional.';

export class CashOutAddressFieldError extends Error {
  readonly field: string;

  constructor(field: string, message: string) {
    super(message);
    this.name = 'CashOutAddressFieldError';
    this.field = field;
  }
}

interface ApiErrorBody {
  field?: unknown;
  message?: unknown;
}

function errorBody(error: unknown): ApiErrorBody | null {
  if (!error || typeof error !== 'object' || !('response' in error)) {
    return null;
  }

  const data = (error as { response?: { data?: unknown } }).response?.data;
  if (!data || typeof data !== 'object') {
    return null;
  }

  return data as ApiErrorBody;
}

export function isCashOutAddressFieldError(error: unknown): error is CashOutAddressFieldError {
  if (error instanceof CashOutAddressFieldError) {
    return true;
  }

  return (
    error instanceof Error &&
    error.name === 'CashOutAddressFieldError' &&
    'field' in error &&
    typeof (error as CashOutAddressFieldError).field === 'string'
  );
}

export function readCashOutAddressFieldError(error: unknown): CashOutAddressFieldError | null {
  const body = errorBody(error);
  if (!body || typeof body.field !== 'string' || body.field.length === 0 || typeof body.message !== 'string') {
    return null;
  }

  return new CashOutAddressFieldError(body.field, body.message);
}

export function shouldSkipAddressSaveToast(requestPath: string, data: unknown): boolean {
  if (!requestPath.endsWith(CASH_OUT_ADDRESS_SAVE_ENDPOINT)) {
    return false;
  }

  if (!data || typeof data !== 'object') {
    return false;
  }

  const body = data as ApiErrorBody;
  if (typeof body.field === 'string' && body.field.length > 0) {
    return true;
  }

  return body.message === CASH_OUT_ADDRESS_SAVE_RETRY_MESSAGE;
}
